/**
 * HQ 인증 서비스.
 */
import hqApi, { HQ_TOKEN_KEY, HQ_REFRESH_KEY, HQ_USER_KEY } from './hqApiClient';

export interface HqUser {
  user_id: string;
  email: string;
  name: string;
  role: 'hq_admin' | 'hq_staff';
  franchise_brand_id: string | null;
  brand_name?: string | null;
}

export interface HqLoginResponse {
  access_token: string;
  refresh_token: string;
  token_type: string;
  user: HqUser;
}

export const hqAuthService = {
  async login(email: string, password: string): Promise<HqLoginResponse> {
    const { data } = await hqApi.post<HqLoginResponse>('/api/v1/hq/auth/login', {
      email,
      password,
    });
    localStorage.setItem(HQ_TOKEN_KEY, data.access_token);
    localStorage.setItem(HQ_REFRESH_KEY, data.refresh_token);
    localStorage.setItem(HQ_USER_KEY, JSON.stringify(data.user));
    return data;
  },

  async me(): Promise<HqUser> {
    const { data } = await hqApi.get<HqUser>('/api/v1/hq/auth/me');
    localStorage.setItem(HQ_USER_KEY, JSON.stringify(data));
    return data;
  },

  logout(): void {
    localStorage.removeItem(HQ_TOKEN_KEY);
    localStorage.removeItem(HQ_REFRESH_KEY);
    localStorage.removeItem(HQ_USER_KEY);
  },

  isAuthenticated(): boolean {
    return Boolean(localStorage.getItem(HQ_TOKEN_KEY));
  },

  getCachedUser(): HqUser | null {
    const raw = localStorage.getItem(HQ_USER_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as HqUser;
    } catch {
      return null;
    }
  },
};
